import React from 'react';

import Input from '../input/input.jsx';


const PasswordInput = ({disabled, err, onChange, onBlur, defaultValue, onActualChange, placeholder, verify}) => (
    <Input
        type="password"
        disabled={disabled}
        onBlur={onBlur}
        err={err}
        defaultValue={defaultValue}
        onActualChange={onActualChange}
        onChange={onChange}
        placeholder={placeholder || "请输入密码"}
        verify={verify || (v => {
            if (!v.length) {
                throw new Error('请输入密码');
            }else if (v.length < 6) {
                throw new Error('密码至少需要6位字符，且不能为纯数字');
            }else if (!/[^\d]+/.test(v)) {
                throw new Error('密码不能为纯数字');
            }
            return true;
        })}
    />
);

export default PasswordInput;
